import React, { useState, createContext, useContext } from 'react';
import { Redirect } from 'react-router-dom';
export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({});

  //   const login = (user) => {
  //     setUser(user);
  //   };

  //   const logout = () => {
  //     setUser(null);
  //   };

  //   // Redirect to login page if user is null
  if (user === null) {
    return <Redirect to='/login' />;
  }
  const contextValue = {
    user,
    setUser,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
